<template>
  <section
    v-if="getVariationsActive"
    class="variation-listing-filters"
  >
    <div class="variation-listing-filters-wrapper">
      <BaseGroupListingFilters
        v-if="getListingVariationGroupCombos.length > 0"
        :base-group-combos="getListingVariationGroupCombos"
      >
      </BaseGroupListingFilters>
      <TextRangeGroupListingFilters
        v-if="textRangeGroupCombos.length > 0"
        :text-range-group-combos="textRangeGroupCombos"
      >
      </TextRangeGroupListingFilters>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep, filter, isUndefined } from 'lodash'
import RangeGroupChunkModel from '../Models/RangeGroupChunkModel'
import BaseGroupListingFilters from '../Components/BaseGroupListingFilters'
import TextRangeGroupListingFilters from '../Components/TextRangeGroupListingFilters'

export default {
  name: 'VariationListingFilters',
  props: [],
  components: {
    TextRangeGroupListingFilters,
    BaseGroupListingFilters
  },
  computed: {
    ...mapGetters([
      'getListingVariationGroupCombos',
      'getVariationsActive',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getActiveVariationFilters',
      'config'
    ]),
    textRangeGroupCombos () {
      return [...this.textRangePerValueGroupCombos, ...this.textRangePerCountGroupCombos]
    },
    textRangePerValueGroupCombos () {
      const combos = cloneDeep(this.getListingVariationGroupCombos)
      for (const combo of combos) {
        if (combo.variationDisplayType !== 'text-range-per-value') {
          continue
        }

        if (combo.variationDisplayType === 'text-range-per-value' && combo.variationGroupStep > 0) {
          const chunks = new RangeGroupChunkModel(combo, this.t).createChunksForPerValueGroup()
          combo.variations = {
            chunks: chunks
          }
        }
      }

      return filter(combos, (combo) => {
        return (!isUndefined(combo.variations.chunks) && combo.variations.chunks.length > 0)
      })
    },
    textRangePerCountGroupCombos () {
      const combos = cloneDeep(this.getListingVariationGroupCombos)
      for (const combo of combos) {
        if (combo.variationDisplayType !== 'text-range-per-count') {
          continue
        }

        if (combo.variationDisplayType === 'text-range-per-count' && combo.variationGroupStep > 0) {
          const chunks = new RangeGroupChunkModel(combo, this.t).createChunksForPerCountGroup()
          combo.variations = {
            chunks: chunks
          }
        }
      }

      return filter(combos, (combo) => {
        return (!isUndefined(combo.variations.chunks) && combo.variations.chunks.length > 0)
      })
    },
    urlNoFilters () {
      const url = '/' + this.config.url.lang + this.getUriWithoutOffset
      if (this.getIsTopLevelCategory) {
        return url + '/1'
      }
      return url
    }
  }
}
</script>
